// extracted by mini-css-extract-plugin
module.exports = {"container":"GlobalHeader_Dropdown_container","scrolled":"GlobalHeader_Dropdown_scrolled","wrapper":"GlobalHeader_Dropdown_wrapper","option":"GlobalHeader_Dropdown_option"};